import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompressorRotary = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 50,
		rx: 50,
		ry: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 7.0 L 95.0 28.0 M 25.0 93.0 L 95.0 72.0 M 30.0 50.0 L 70.0 50.0 M 65.0 37.0 A 20.0 20.0 0.0 0 1 65.0 63.0 M 35.0 37.0 A 20.0 20.0 0.0 0 0 35.0 63.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCompressorRotary;
